import { SET_WINDOW_SIZE, UPDATE_DATA, SET_INFOGRAPHIC } from '../actions'

const INITIAL_STATE = {
  size: {
    width: null,
    height: null,
  },
  data: null,
  infographic: null,
};

function appState(state=INITIAL_STATE, action){

  switch (action.type) {
    case SET_WINDOW_SIZE:
      if (action.payload.height < 350 ) { action.payload.height = 350 }
      return Object.assign({}, state, { size: action.payload });

    case UPDATE_DATA:
      return Object.assign({}, state, { data: action.payload });

    case SET_INFOGRAPHIC:
      return Object.assign({}, state, { infographic: action.payload });

    default:
      return state;
  }
}

export default appState;



// WEBPACK FOOTER //
// ./src/store/reducers/appstate.js